import {
  Box,
  Flex,
  Heading,
  Text,
  Input,
  Image,
  Textarea,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { Button } from "../components/ui/button";
import { Field } from "../components/ui/field";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

import WorldMap from "../assets/images/worldMap.png";

export const Contact = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Header dark={false} />

      <Flex
        bg="#F4F8F8"
        py={{ base: "64px", md: "87px" }}
        px={{ base: "16px", md: "70px", "2xl": 0 }}
        borderTopWidth={"1px"}
        borderColor={"#E8E9EA"}
      >
        <Flex
          maxW={{ base: "100%", "2xl": "1300px" }}
          mx="auto"
          flexDir={"column"}
          align={"center"}
          justify={"center"}
        >
          <Flex
            align={"center"}
            justify={"center"}
            borderWidth={"1px"}
            borderColor={"#8AA7A5"}
            borderRadius={"30px"}
            backgroundColor={"rgba(235, 240, 240, 0.5)"}
            py={"11px"}
            px="20px"
            mb="12px"
            fontFamily={"Sora-Regular"}
          >
            <Text fontSize={"13px"} fontWeight={500} color={"#346864"}>
              CONTACT
            </Text>
          </Flex>

          <Heading
            fontSize={{ base: "28px", md: "48px" }}
            fontWeight={500}
            color={"#101828"}
            mt={{ base: "8px", md: "12px" }}
            fontFamily={"DMSans-Medium"}
          >
            Chat to us
          </Heading>

          <Flex
            mt={{ base: "34px", md: "87px" }}
            gap={"80px"}
            align={"center"}
            justify={"space-between"}
            flexDirection={{ base: "column-reverse", md: "row" }}
            fontFamily={"Sora-Regular"}
          >
            <Box bg="white" borderRadius={"16px"} p={"40px"} w="423px">
              <Field
                label="First Name"
                mb="24px"
                //   invalid={!!errors.firstName}
                //   errorText={errors.firstName?.message}
              >
                <Input
                  // {...register("firstName", {
                  //   required: "First name is required",
                  // })}
                  placeholder="Enter name"
                  variant="outline"
                  borderColor={"#D0D5DD"}
                  borderRadius={"9px"}
                  _hover={{
                    borderColor: "#346864",
                    transform: "scale(1.03)", // Slightly enlarge the button
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
                  }}
                  _focus={{
                    borderColor: "#346864",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
                  }}
                  transition="all 0.2s ease-in-out" // Smooth transition
                />
              </Field>

              <Field
                label="Last Name"
                mb="24px"
                //   invalid={!!errors.lastName}
                //   errorText={errors.lastName?.message}
              >
                <Input
                  // {...register("lastName", {
                  //   required: "Last name is required",
                  // })}
                  placeholder="Enter name"
                  variant="outline"
                  borderColor={"#D0D5DD"}
                  borderRadius={"9px"}
                  _hover={{
                    borderColor: "#346864",
                    transform: "scale(1.03)", // Slightly enlarge the button
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
                  }}
                  _focus={{
                    borderColor: "#346864",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
                  }}
                  transition="all 0.2s ease-in-out" // Smooth transition
                />
              </Field>

              <Field
                label="Email"
                mb="24px"
                //   invalid={!!errors.email}
                //   errorText={errors.email?.message}
              >
                <Input
                  // {...register("email", {
                  //   required: "Email is required",
                  // })}
                  placeholder="Enter email"
                  variant="outline"
                  borderColor={"#D0D5DD"}
                  borderRadius={"9px"}
                  _hover={{
                    borderColor: "#346864",
                    transform: "scale(1.03)", // Slightly enlarge the button
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
                  }}
                  _focus={{
                    borderColor: "#346864",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
                  }}
                  transition="all 0.2s ease-in-out" // Smooth transition
                />
              </Field>

              <Field
                label="Message"
                mb="4px"
                //   invalid={!!errors.message}
                //   errorText={errors.message?.message}
                //   required={pastmessage === "Specific"}
              >
                <Textarea
                  // {...register("message")}
                  placeholder="Enter message"
                  variant="outline"
                  borderColor={"#D0D5DD"}
                  borderRadius={0}
                  resize={"vertical"}
                  rows={4}
                  _hover={{
                    borderColor: "#346864",
                    transform: "scale(1.03)",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                  _focus={{
                    borderColor: "#346864",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                  transition="all 0.2s ease-in-out"
                />
              </Field>

              <Text color={"#667085"} fontSize={"16px"} mb="24px">
                0/100
              </Text>

              <Button w={"100%"} onClick={() => navigate("/success")}>
                Submit
              </Button>
            </Box>

            <Image
              src={WorldMap}
              h={{ base: "auto", md: "456px" }}
              w={{ base: "100%", md: "60%" }}
              objectFit={"cover"}
            />
          </Flex>
        </Flex>
      </Flex>

      <Footer />
    </Box>
  );
};
